import { GroupByMode } from '@griply/types';
import { buildAllTasksReorderUserSettings } from '@griply/utils';
import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';
import { useUpdateTasksMutation } from 'shared/hooks/queries/use-update-tasks-mutation';
import { useUpdateRelationshipsReferences } from 'shared/hooks/use-update-relationships-references';
import { ID } from 'shared/types/id';
import { RelationshipUpdate } from 'shared/types/relationship';
import { UpdateTask } from 'shared/types/task';

export const useAllTasksOnReorder = (
  groupBy: GroupByMode | undefined | null,
) => {
  const updateSettings = useUpdateUserSettings();
  const { mutate: updateTasks } = useUpdateTasksMutation();
  const updateRelationships = useUpdateRelationshipsReferences();

  return useCallback(
    (
      updatedSections: { id: ID; taskSorting: ID[] }[],
      updatedTasks: UpdateTask[],
      relationshipUpdates?: RelationshipUpdate[],
    ) => {
      updateSettings(
        buildAllTasksReorderUserSettings({ updatedSections, groupBy }),
      );
      updateTasks(updatedTasks);

      if (relationshipUpdates?.length) {
        updateRelationships(relationshipUpdates);
      }
    },
    [groupBy, updateSettings, updateTasks, updateRelationships],
  );
};
